<template>
  <v-layout class="pa-2">
    <img class="c-align-self-start" src="@/assets/img/illustrations/production.png" alt="cardboard box" width="56px">
    <div>
      <v-layout>
        <router-link
        class="rlink-hover font-weight-medium color1--text"
        style="text-decoration: none;display:inline-flex;align-items: center;"
        :to="{ path: '/production/' + item.production_id}" @click.native.stop>
          Production
          <span class="ml-1">{{ item.production_id }}</span>
        </router-link>
        <v-spacer></v-spacer>
        <v-chip v-if="!item.completed" 
        small disabled label class="caption" color="color1" text-color="white">
          in process
        </v-chip>
      </v-layout>
      <div>
        <c-metric-selector
        :inventoryItemID="item.inventory_item_id" 
        :realValue="item.quantity"
        labelMode
        alwaysScale
        ></c-metric-selector>
      </div>
      <div>
        {{ item.customer_name }}
      </div>
      <div class="caption">
        {{ dateFromNow }}
        &nbsp;-&nbsp;
        {{ humanDate }}
      </div>
    </div>
    <!-- {{ item }} -->
  </v-layout>
</template>

<script>
export default {
  props: ['item'],
  computed: {
    humanDate () {
      if (this.$moment.utc(this.item.date_end).isValid()) {
        return this.$moment(this.item.date_end).format('ddd D MMM YYYY, h:mm')
      }
      return ''
    },
    dateFromNow () {
      if (this.$moment.utc(this.item.date_end).isValid()) {
        return this.$moment.utc(this.item.date_end).fromNow()
      }
      return ''
    }
  }
}
</script>
